import React from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useRef } from "react";
import Footer from "../../Footer";

import "./Cliente.scss";
import Logo from "../../../assets/images/02_washpass.png";
import Why1 from "../../../assets/images/lps/cliente/why1.png";
import Why2 from "../../../assets/images/lps/cliente/why2.png";
import Why3 from "../../../assets/images/lps/cliente/why3.png";
import How1 from "../../../assets/images/lps/cliente/how1.png";
import HowItem1 from "../../../assets/images/lps/cliente/how-item1.png";
import HowItem2 from "../../../assets/images/lps/cliente/how-item2.png";
import HowItem3 from "../../../assets/images/lps/cliente/how-item3.png";
import Care1 from "../../../assets/images/lps/cliente/care1.png";
import AppleStore from "../../../assets/images/lps/cliente/app_store.png";
import GooglePlay from "../../../assets/images/lps/cliente/google-play.png";
import AppleStoreButton from "../../../assets/images/lps/cliente/apple_store_button.png";
import GooglePlayButton from "../../../assets/images/lps/cliente/google_play_button.png";

const ClienteLP = () => {
  const qrCode = useRef<HTMLInputElement>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const scrollToQrCode = () => {
    window.scrollTo(0, 0);
    if (qrCode.current) {
      qrCode.current.focus();
    }
  };

  const appStoreLink = "https://apps.apple.com/br/app/washpass/id6503068980";
  const googlePlayLink =
    "https://play.google.com/store/apps/details?id=washpass.app&hl=pt_BR";

  return (
    <>
      <div className="LpCliente">
        <Box className="MainSection">
          <Container maxWidth="lg">
            <img src={Logo} className="Logo" />

            <Grid container justifyContent={"space-evenly"}>
              <Grid item className="Presentation" xs={12} sm={6}>
                <Typography variant="h2" component="h2" className="MainText">
                  Cadastre-se agora e tenha lavagens ilimitadas!
                </Typography>
                <Divider className="Divider" />
                <Typography
                  variant="h3"
                  component="p"
                  className="SecondaryText"
                >
                  Com o WashPass, você garante um carro sempre limpo, sem
                  complicações.
                </Typography>
              </Grid>
              <Grid item className="Form" xs={12} sm={6}>
                <Box className="FormBox" ref={qrCode}>
                  <Typography variant="h3" className="FormTitle">
                    <p style={{ marginBottom: 0 }}>
                      Seu carro sempre limpo a um toque de distância.
                    </p>
                    <span>Baixe o app!</span>
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", justifyContent: "center", gap: isMobile ? "36px" :"12px" }}>
                    <Box sx={{ textAlign: "center" }}>
                      <img src={AppleStore} style={{ width: "100%" }} />
                      <Link href={appStoreLink} target="_blank">
                        <img
                          src={AppleStoreButton}
                          style={{
                            width: "100%",
                            maxWidth: "170px",
                            marginTop: "32px",
                          }}
                        />
                      </Link>
                    </Box>
                    <Box sx={{ textAlign: "center" }}>
                      <img src={GooglePlay} style={{ width: "100%" }} />
                      <Link href={googlePlayLink} target="_blank">
                        <img
                          src={GooglePlayButton}
                          style={{
                            width: "100%",
                            maxWidth: "170px",
                            marginTop: "32px",
                          }}
                        />
                      </Link>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>

        <Box className="WhySection">
          <Container maxWidth="lg">
            <Typography variant="h2" component="h2" className="WhyTitle">
              Por que se cadastrar no WashPass?
            </Typography>
            <Grid container>
              <Grid item xs={4} className="WhyItem">
                <img src={Why1} />
                <Typography variant="h4" component="h4">
                  Economia mensal
                </Typography>
                <Typography variant="body1" component="p">
                  Lave seu carro quantas vezes você desejar, sem nenhuma
                  limitação.
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  className="WashButton"
                  onClick={() => scrollToQrCode()}
                >
                  Comece a usar já
                </Button>
              </Grid>
              <Grid item xs={4} className="WhyItem">
                <img src={Why2} />
                <Typography variant="h4" component="h4">
                  Qualidade garantida
                </Typography>
                <Typography variant="body1" component="p">
                  Parceiros selecionados e avaliados garantem o cuidado do seu
                  veículo.
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  className="WashButton"
                  onClick={() => scrollToQrCode()}
                >
                  Inscreva-se e aproveite
                </Button>
              </Grid>
              <Grid item xs={4} className="WhyItem">
                <img src={Why3} />
                <Typography variant="h4" component="h4">
                  Facilidade total
                </Typography>
                <Typography variant="body1" component="p">
                  Um carro sempre limpo, sem precisar se preocupar.
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  className="WashButton"
                  onClick={() => scrollToQrCode()}
                >
                  Garanta seu WashPass
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Box>

        <Box className="HowSection">
          <Container maxWidth="lg">
            <Grid container>
              <Grid item xs={12} md={6} className="HowLeft">
                <img src={How1} />
              </Grid>
              <Grid item xs={12} md={6} className="HowRight">
                <Typography variant="h2" component="h2">
                  Como funciona
                </Typography>
                <Box className="how-item">
                  <img src={HowItem1} />
                  <div>
                    <Typography variant="subtitle1" component="h3">
                      Baixe o APP
                    </Typography>
                    <Typography variant="body2" component="p">
                      Baixe o app na loja do seu smartphone
                    </Typography>
                  </div>
                </Box>
                <Box className="how-item">
                  <img src={HowItem2} />
                  <div>
                    <Typography variant="subtitle1" component="h3">
                      Faça seu cadastro
                    </Typography>
                    <Typography variant="body2" component="p">
                      Se cadastre e conheça nossa rede de parceiros
                    </Typography>
                  </div>
                </Box>
                <Box className="how-item">
                  <img src={HowItem3} />
                  <div>
                    <Typography variant="subtitle1" component="h3">
                     Escolha seu plano
                    </Typography>
                    <Typography variant="body2" component="p">
                      Tenha lavagens ilimitadas e seu carro sempre limpo
                    </Typography>
                  </div>
                </Box>
                <Button
                  className="WashButton"
                  variant="contained"
                  size="large"
                  onClick={() => scrollToQrCode()}
                >
                  Quero meu WashPass
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Box>

        <Box className="CareSection">
          <Container maxWidth="lg">
            <Grid container>
              <Grid item xs={12} sm={6} className="CareLeft">
                <Typography variant="h2" component="h2">
                  Cuide do seu carro com o WashPass
                </Typography>
                <Typography variant="body1" component="p">
                  Com lavagens ilimitadas, você cuida do seu carro sem se
                  preocupar com o custo por lavagem.
                </Typography>
                <Typography variant="body1" component="p">
                  Preencha o formulário para começar a usar o WashPass e
                  descubra como é fácil manter seu carro sempre limpo.
                </Typography>
                <Button
                  className="WashButton"
                  variant="contained"
                  size="large"
                  onClick={() => scrollToQrCode()}
                >
                  Cuide do seu carro
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} className="CareRight">
                <img src={Care1} />
              </Grid>
            </Grid>
          </Container>
        </Box>

        <Footer />
      </div>
    </>
  );
};

export default ClienteLP;
